export default __webpack_public_path__ + "static/media/valdisere-3x.519021ba.webp";